<script>
import { mapState } from "vuex";

import Modal from "@/components/_Shared/Modal/Index";
import Title from "@/components/_Shared/Title";
import Tip from "@/components/_base/Tip";

import Loader from "./Loader";
import Empty from "./Empty";
import NewAddress from "./NewAddress";
import Address from "./Address";

export default {
  components: {
    Modal,
    Title,
    Tip,
    Loader,
    Empty,
    NewAddress,
    Address
  },

  computed: {
    ...mapState("addresses", ["addresses", "preloader"]),
    ...mapState("orderScheduler", ["selectedAddress"])
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <Title title="Selecione o local da limpeza para continuar" />
    </template>

    <template slot="body">
      <NewAddress v-if="!preloader"/>

      <Loader v-if="preloader" />

      <Empty v-else-if="!addresses || !addresses.length" />

      <Address
          v-else
          v-for="address in addresses"
          :key="address.id"
          :address="address"
          :selected="selectedAddress === address.id"
          @addressSelected="$emit('addressSelection')"
        />
    </template>

    <template slot="footer">
      <Tip>Selecione, altere ou adicione um endereço</Tip>

      <button
        class="btn bg-purple"
        @click="$emit('addressSelection')"
      >
        <span>Voltar</span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
button {
  width: 100%;
  max-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Address/Addresses.vue